<template>
  <div id="shopifyAuthPage" class="flex-col justify-center items-center min-h-screen bg-gray-100 flex">
    <!-- Authenticating -->
    <div v-if="isLoading" class="flex flex-col justify-center items-center h-1/2 w-1/2">
      <div class="pt-10">
        <img style="height: 100px; margin-bottom: 50px" src="@/assets/images/logo-full.png" />
      </div>
      <i class="mt-10 fa-sharp-duotone fa-solid fa-spinner-third fa-spin text-black-600 text-xl" style="font-size: 80px; margin-bottom: 50px; --fa-animation-duration: 2s"></i>
      <div class="pt-0 text-center text-gray-400" style="margin-bottom: 50px">Fetching Details</div>
    </div>

    <!-- Shopify Info -->
    <div v-else class="items-center w-1/2 border rounded-xl bg-white">
      <div class="border-b py-6 px-4 w-full text-center border">
        <i class="fa-brands fa-shopify" style="color: #7bb342; font-size: 100px"></i>
        <div class="pt-4 text-gray-500">{{ shopifyInfo.name }}</div>
      </div>
      <!-- IF sync is in progress, show sync in progress with loader. -->
      <div class="p-10 pb-4">
        <div class="font-bold text-gray-700" v-if="shopifyInfo.syncing">
          <i class="fa-sharp-duotone fa-solid fa-spinner-third fa-spin text-gray-600 text-xl"></i>
          &nbsp;<span class="text-xl">Sync In Progress</span>
          <div class="text-gray-500 text-base font-normal">We are syncing your past orders, customers etc.</div>
        </div>
        <div class="font-bold text-gray-700" v-else>
          <span class="text-xl">Synced & Connected</span>
          <div class="text-gray-400 text-base font-normal">Your store is synced with Growlytics.</div>
        </div>
      </div>

      <div class="p-10 pt-0">
        <div>
          <span v-if="shopifyInfo.syncing">
            <i class="fa-solid fa-spinner-third fa-spin text-gray-600"></i>
          </span>
          <span v-else>
            <i class="fa-solid fa-check-circle text-green-500 text-xl"></i>
          </span>
          {{ shopifyInfo.customers }} customers synced
        </div>

        <div class="pt-1">
          <span v-if="shopifyInfo.syncing">
            <i class="fa-solid fa-spinner-third fa-spin text-gray-600"></i>
          </span>
          <span v-else>
            <i class="fa-solid fa-check-circle text-green-500 text-xl"></i>
          </span>
          {{ shopifyInfo.orders }} orders synced
        </div>

        <div class="pt-1">
          <span v-if="shopifyInfo.syncing">
            <i class="fa-solid fa-spinner-third fa-spin text-gray-600"></i>
          </span>
          <span v-else>
            <i class="fa-solid fa-check-circle text-green-500 text-xl"></i>
          </span>
          {{ shopifyInfo.products }} products synced
        </div>
      </div>

      <div class="p-10 pt-0">
        <el-button type="primary" size="large" @click="$router.push('/')">Go to Dashboard &nbsp;&nbsp;<i class="fa-regular fa-arrow-right-long"></i> </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import shopifyWelcomeComponent from './shopifyWelcomeComponent';
export default shopifyWelcomeComponent;
</script>

<style lang="scss" src="./shopifyWelcome.scss"></style>
